import React from 'react'
import { CardInfo } from '../Components/elementos/CardInfo'
import styled from 'styled-components'

const StyledSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 40px;
  padding: 20px;
  margin-bottom: 40px;
`

const Avisos = () => {
  return (
    <StyledSection id='avisos'>
      {/* <CardInfo
        title='Rematrícula 24.2 Dentro do Prazo:'
        subtitle='08 a 27/07'
        description='A partir do dia 28/07 a sua Rematrícula estará Fora do Prazo!'
        disabled={true}
        hideOnMobile={true}
      /> */}

      <CardInfo
        title='Rematrícula 25.1 - Dentro do Prazo:'
        subtitle='06 a 19 de JAN'
        description=''
        disabled={false}
      />

      <CardInfo
        title='Rematrícula 25.1 Fora do Prazo* '
        subtitle='A partir de  20 de JAN'
        description='*verificar prazos da Rematrículas no Calendário Acadêmico.'
        disabled={false}
        hideOnMobile={true}
      />
    </StyledSection>
  )
}

export default Avisos
